// src/api/prepExtras.js
import api from "./api"; // your axios instance with auth headers

// NOTES
export const fetchNotes = (materialId) => api.get(`/prep/${materialId}/notes`);
export const addNote = (materialId, data) => api.post(`/prep/${materialId}/notes`, data);
export const updateNote = (materialId, noteId, data) => api.put(`/prep/${materialId}/notes/${noteId}`, data);
export const deleteNote = (materialId, noteId) => api.delete(`/prep/${materialId}/notes/${noteId}`);

// HIGHLIGHTS
// ✅ Corrected API endpoints
export const fetchHighlights = (materialId) => 
  api.get(`/prephighlights/${materialId}`);

export const addHighlight = (data) => 
  api.post(`/prephighlights`, data);

export const updateHighlight = (id, data) => 
  api.put(`/prephighlights/${id}`, data);

export const deleteHighlight = (id) => 
  api.delete(`/prephighlights/${id}`);
